import {Map, List, fromJS} from 'immutable';
import axios from "axios";
import { toast } from "react-toastify";

if (sessionStorage.getItem("authToken")) {
    axios.defaults.headers.common['Auth-Token'] = sessionStorage.getItem("authToken");
}

export const types = {
    INIT: 'DASHBOARD/INIT',
    FETCH_STORE_REPORTS: 'DASHBOARD/FETCH_STORE_REPORTS',
    FETCH_STORE_REPORTS_SUCCESS: 'DASHBOARD/FETCH_STORE_REPORTS_SUCCESS'
};

export const initialState = fromJS({
    storeReports: []
});

export default (state = initialState, action) => {
    switch (action.type) {
        case types.INIT:
            return state;
        case types.FETCH_STORE_REPORTS_SUCCESS:
            return state.set('storeReports', fromJS(action.storeReports));
        default:
            return state
    }
};

export const initialise = () => {
    return (dispatch) => {
        dispatch(fetchStoreReports());
    }
};

export const fetchStoreReports = () => {
    return function (dispatch) {

        const path = __API__ + '/api/ui/areacontrol/storereport';

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(storeReports => {
                dispatch(fetchStoreReportsSuccess(storeReports));
            })
            .catch(error => {
                toast.error('StoreReports konnten nicht geladen werden!');
            });
    }
};

export const fetchStoreReportsSuccess = (storeReports) => {
    return {
        type: types.FETCH_STORE_REPORTS_SUCCESS,
        storeReports: storeReports
    };
};



// WEBPACK FOOTER //
// ./src/admin/dashboard/reducer.js